export const routes = {
    // Root
    selectPlan: '/select-plan',
    wizard: {
        index: '/wizard',
        restart: '/wizard#restart',
        config: '/wizard/configure',
        network: {
            saas: '/wizard/configure/saas',
            ias: '/wizard/configure/ias',
        },
        shield: {
            domain: '/wizard/configure/domain-filtering',
            traffic: '/wizard/configure/traffic-filtering',
            combined: '/wizard/configure/secure-internet-access',
        },
        deploy: {
            region: '/wizard/deploy/region',
            method: '/wizard/deploy/method',
        },
        connect: '/wizard/connect',
        summary: '/wizard/summary',
    },

    // UDM:
    users: '/users',
    userDetails: '/users/:id',
    userDetailsDevices: '/users/:id/devices',

    groups: '/groups',
    groupDetails: '/groups/:id',
    groupDetailsUsers: '/groups/:id/users',
    groupDetailsAccess: '/groups/:id/access',

    devices: '/devices',

    locationContext: {
        all: '/location-context',
        single: '/location-context/:id',
        add: '/location-context/create',
        edit: '/location-context/:id/edit',
    },
    devicePosture: {
        all: '/device-posture',
        single: '/device-posture/:id',
        add: '/device-posture/create',
        edit: '/device-posture/:id/edit',
    },

    // NAM:
    networks: '/networks',
    networkApplications: '/networks/applications',
    networkIPServices: '/networks/ip-services',
    networkConnectors: '/networks/connectors',
    networksCreate: '/networks/create',
    networksView: '/networks/:id',
    networksEdit: '/networks/:id/edit',
    networkViewApplications: '/networks/:id/applications',
    networkViewIPServices: '/networks/:id/ip-services',
    networkViewConnectors: '/networks/:id/connectors',
    networksWizard: {
        initial: '/networks/wizard/',
        scenario: '/networks/wizard/scenario',
        scenarioWithNetworkId: '/networks/wizard/scenario/:networkId',
        defineNetwork: '/networks/wizard/define-network',
        defineNetworkWithNetworkId: '/networks/wizard/define-network/:networkId',
        defineApplication: '/networks/wizard/define-application',
        defineApplicationWithNetworkId: '/networks/wizard/define-application/:networkId',
        defineConnector: '/networks/wizard/define-connector/',
        defineConnectorWithNetworkId:
            '/networks/wizard/define-connector/:networkItemId/:connectorId',
        configureConnector: '/networks/wizard/configure-connector/',
        configureConnectorInitial:
            '/networks/wizard/configure-connector/:networkItemId/:connectorId',
        configureConnectorPlatform:
            '/networks/wizard/configure-connector/:networkItemId/:connectorId/:platform',
        configureConnectorPlatformHowTo:
            '/networks/wizard/configure-connector/:networkItemId/:connectorId/:platform/how-to',
        configureInternetAccess: '/networks/wizard/configure-internet-access',
        configureInternetAccessWithNetworkId:
            '/networks/wizard/configure-internet-access/:networkId',
        configureRouting: '/networks/wizard/configure-routing',
        configureRoutingWithNetworkId: '/networks/wizard/configure-routing/:networkId',
        configureAccessGroup: '/networks/wizard/configure-access-group',
        configureAccessGroupWithNetworkId: '/networks/wizard/configure-access-group/:networkId',
        configureRoutesAndIPServices: '/networks/wizard/configure-routes-and-ip-services',
        configureRoutesAndIPServicesWithNetworkId:
            '/networks/wizard/configure-routes-and-ip-services/:networkId',
    },
    hostWizard: {
        initial: '/hosts/wizard/',
        defineHost: '/hosts/wizard/define-host',
        defineHostWithHostId: '/hosts/wizard/define-host/:hostId',
        defineConnector: '/hosts/wizard/define-connector/',
        defineConnectorWithHostsId: '/hosts/wizard/define-connector/:networkItemId/:connectorId',
        defineApplication: '/hosts/wizard/define-application',
        defineApplicationWithHostId: '/hosts/wizard/define-application/:hostId',
        defineIPService: '/hosts/wizard/define-ip-service',
        defineIPServiceWithHostId: '/hosts/wizard/define-ip-service/:hostId',
        configureAccessGroup: '/hosts/wizard/configure-access-group/',
        configureAccessGroupWithHostId: '/hosts/wizard/configure-access-group/:hostId',
    },
    deployHostConnector: '/deploy-connector/hosts/:networkItemId/:connectorId/:provider?',
    deployNetworkConnector: '/deploy-connector/networks/:networkItemId/:connectorId/:provider?',
    ipSecConfiguration: {
        initial: '/configure-connector/:networkItemId/:connectorId',
        platform: '/configure-connector/:networkItemId/:connectorId/:platform',
        howTo: '/configure-connector/:networkItemId/:connectorId/:platform/how-to',
        view: '/configure-connector/:networkItemId/:connectorId/view',
        edit: '/configure-connector/:networkItemId/:connectorId/edit',
    },
    hosts: '/hosts',
    hostsCreate: '/hosts/create',
    hostsView: '/hosts/:id',
    hostsEdit: '/hosts/:id/edit',
    hostApplications: '/hosts/applications',
    hostIPServices: '/hosts/ip-services',
    hostConnectors: '/hosts/connectors',
    hostViewApplications: '/hosts/:id/applications',
    hostViewIPServices: '/hosts/:id/ip-services',
    hostViewConnectors: '/hosts/:id/connectors',

    // Access:
    accessControl: '/access-control',
    accessGroupCreate: '/access-control/create',
    accessGroupEdit: '/access-control/:accessGroupId',
    accessGroupEditV2: '/access-control/:accessGroupId/edit',
    accessInternet: {
        default: '/access-internet',
        groups: '/access-internet/groups',
        networks: '/access-internet/networks',
        hosts: '/access-internet/hosts',
    },

    // Settings:
    networkSettings: '/settings/network',
    userSettings: '/settings/user',
    userAuth: '/settings/authentication',
    samlGroupMapping: '/settings/saml-group-mapping',
    notificationPreferences: '/settings/notification-preferences',
    dnsServers: '/settings/dns',
    dnsRecords: '/settings/dns-records',
    ldapSettings: {
        configuration: '/settings/ldap',
        configurationEdit: '/settings/ldap/edit',
        groupMapping: '/settings/ldap-group-mapping',
        groupMappingEdit: '/settings/ldap-group-mapping/edit',
    },

    // MFE Apps
    statusPage: '/status',
    cyberShieldV2: {
        overview: '/cybershield',
        configuration: '/cybershield/configuration',
        metrics: '/cybershield/metrics',
    },
    publishing: '/publishing',
    accessVisibility: '/access-visibility',
    logStreaming: '/log-streaming',
    dnsResolutions: '/dns-log',
    auditLog: '/audit-log',

    // SSO:
    ssoAccount: '/account',
    ssoSecuritySettings: '/account/security',
    ssoApi: '/api',
    ssoSamlConfigure: {
        serviceProvider: '/saml-configure/service-provider',
        identityProvider: '/saml-configure/identity-provider',
        confirmation: '/saml-configure/confirmation',
        attributeMapping: '/saml-configure/attribute-mapping',
        scim: '/saml-configure/scim',
    },

    // MainUI:
    tenants: '/tenants',
    quickStart: '/quick-start',
    instructions: '/instructions',
    getConnectedUnified: '/get-connected',
} as const;
